import {hexToRgbA} from "./app";

const win: any = window;

function rgbaToHex(rgbaString) {
    function padZero(str) {
        return str.length === 1 ? '0' + str : str;
    }

    const rgbaRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d+(\.\d+)?)\)$/;
    if (!rgbaRegex.test(rgbaString)) {
        throw new Error('Invalid RGBA string format');
    }
    const [_, red, green, blue, alpha] = rgbaRegex.exec(rgbaString);
    const redInt = parseInt(red, 10);
    const greenInt = parseInt(green, 10);
    const blueInt = parseInt(blue, 10);
    const alphaInt = Math.round(parseFloat(alpha) * 255);
    const hexString =
        '#' +
        padZero(redInt.toString(16)) +
        padZero(greenInt.toString(16)) +
        padZero(blueInt.toString(16)) +
        padZero(alphaInt.toString(16));

    return hexString;
}

export function hexToHex(hex, alpha = 1) {
    return rgbaToHex(hexToRgbA(hex, alpha))
}

export function mixColors(color1, color2, ratio) {
    // Chuyển đổi color1 và color2 từ HEX thành dạng RGBA
    const rgba1 = hexToRgba(color1);
    const rgba2 = hexToRgba(color2);

    // Tính toán giá trị màu sau khi trộn
    const mixedR = Math.round(rgba1.r * (1 - ratio) + rgba2.r * ratio);
    const mixedG = Math.round(rgba1.g * (1 - ratio) + rgba2.g * ratio);
    const mixedB = Math.round(rgba1.b * (1 - ratio) + rgba2.b * ratio);
    const mixedA = rgba1.a * (1 - ratio) + rgba2.a * ratio;

    // Chuyển đổi giá trị màu sau khi trộn từ dạng RGBA sang HEX
    return rgbaToHex(`rgba(${mixedR}, ${mixedG}, ${mixedB}, ${mixedA})`);
}

function hexToRgba(hex) {
    // Chuyển đổi từ HEX thành dạng RGBA
    const rgbaRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i;
    const result = rgbaRegex.exec(hex);

    if (!result) {
        throw new Error('Invalid HEX color format');
    }

    const [, r, g, b, a] = result;
    const alpha = a ? parseInt(a, 16) / 255 : 1; // Để alpha mặc định là 1 nếu không có giá trị alpha

    return {
        r: parseInt(r, 16),
        g: parseInt(g, 16),
        b: parseInt(b, 16),
        a: alpha,
    };
}

export function convertSvgColors(svg, colors) {
    colors.map(x => {
        svg = svg.split(x[0]).join(x[1]);
    });
    return `data:image/svg+xml;base64,${window.btoa(svg)}`
}

export function getThemeLogo() {
    //ts-ignore
    return (win?.appTheme?.logoUrl || win?.appTheme?.logoWide || win?.appTheme?.logoFavicon || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==')
}

export function getThemeRawLogo() {
    return (win?.appTheme?.rawLogo)
}

export function getThemeColor() {
    return (win?.appTheme?.color || '#1D896D')
}

export function getThemeIsDefault() {
    return win?.appTheme?.isDefault
}